"use client";

import React from "react";
import { ChevronRight, CreditCard, ShieldCheck, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const creditCardOffers = [{
  id: "cc-001",
  bankName: "交通安排",
  cardName: "交通附加費說明",
  rebateAmount: "實報實銷",
  rebateDesc: "服務人員之來回交通費用將按實際公共交通車資計算。如服務地點位於偏遠地區或需乘搭指定交通工具（如的士），將於預約時與客戶另行確認。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/sc_smart_card_mockup.png",
  applyLink: "/FeeGuidelinesPage",
  features: ["偏遠地區津貼", "公共交通實報實銷", "預約前清晰報價"]
}, {
  id: "cc-002",
  bankName: "節假日安排",
  cardName: "法定假期服務費",
  rebateAmount: "1.5倍",
  rebateDesc: "於法定公眾假期提供之到戶護理服務，收費將按平日價格之 1.5 倍計算。這項安排旨在保障護理人員在節慶期間的辛勞付出與專業服務。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/hang_seng_mmpower_mockup.png",
  applyLink: "/FeeGuidelinesPage",
  features: ["公眾假期適用", "透明收費標準", "保障專業員工"]
}, {
  id: "cc-003",
  bankName: "服務變更",
  cardName: "取消及更改政策",
  rebateAmount: "48小時",
  rebateDesc: "如需更改或取消已預約之服務，請於服務開始前最少 48 小時通知。若逾時通知，本公司將保留收取該次服務全額費用或行政費之權利。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/hsbc_red_card_mockup.png",
  applyLink: "/FeeGuidelinesPage",
  features: ["提前通知免手續費", "資源有效分配", "彈性調整預約"]
}];
export default function CreditCardRebateZone() {
  return <section data-section-id="167203" id="收費常見說明" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] text-primary pointer-events-none">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hex-pattern" width="60" height="52" patternUnits="userSpaceOnUse">
              <path d="M15 0 L45 0 L60 26 L45 52 L15 52 L0 26 Z" stroke="currentColor" strokeWidth="1" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hex-pattern)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4 border border-primary/20">
              <Zap className="w-4 h-4" />
              <span>透明與誠信</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 text-primary">
              收費常見說明
            </h2>
            <p className="text-muted-foreground text-lg">
              我們堅持收費公開透明，無任何隱藏收費。以下為各項服務附加費及條款說明，讓您與家人更安心規劃長期的居家護理方案。
            </p>
          </div>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {creditCardOffers.map((card, index) => <CarouselItem key={card.id} data-index={index} className="basis-full">
                <div className="bg-card border border-primary/10 rounded-[2.5rem] overflow-hidden shadow-xl relative group">
                  {}
                  <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] pointer-events-none transition-opacity duration-700 opacity-50 group-hover:opacity-100" />
                  
                  <div className="flex flex-col lg:flex-row items-stretch">
                    {}
                    

                    {}
                    <div className="w-full lg:w-7/12 p-8 md:p-12 lg:p-16 flex flex-col justify-center relative z-10">
                      <div className="flex items-center gap-3 mb-4">
                        <CreditCard className="w-6 h-6 text-primary" />
                        <h3 className="text-xl font-semibold text-muted-foreground">
                          {card.bankName}
                        </h3>
                      </div>
                      
                      <h4 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
                        {card.cardName}
                      </h4>

                      <div className="mb-8">
                        <div className="text-sm font-bold text-primary tracking-widest uppercase mb-2 flex items-center gap-2">
                          <ShieldCheck className="w-4 h-4" />
                          收費準則
                        </div>
                        {}
                        <div className="text-6xl md:text-8xl font-black text-primary tracking-tighter drop-shadow-sm">
                          {card.rebateAmount}
                        </div>
                      </div>

                      <p className="text-lg text-muted-foreground mb-8 leading-relaxed max-w-xl">
                        {card.rebateDesc}
                      </p>

                      <div className="flex flex-wrap gap-3 mb-10">
                        {card.features.map((feature, fIndex) => <span key={fIndex} className="px-4 py-2 rounded-full bg-secondary text-secondary-foreground text-sm font-medium border border-primary/10">
                            {feature}
                          </span>)}
                      </div>

                      <div className="mt-auto">
                        <Button asChild size="lg" className="w-full sm:w-auto rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-12 py-7 text-xl font-bold shadow-[0_0_30px_rgba(107,33,168,0.2)] hover:shadow-[0_0_40px_rgba(107,33,168,0.3)] transition-all duration-300 group-hover:translate-y-[-2px]">
                          <Link to={card.applyLink}>
                            查看完整準則 <ChevronRight className="ml-2 w-6 h-6" />
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          {}
          <div className="flex items-center justify-center gap-4 mt-12">
            <CarouselPrevious className="relative inset-auto transform-none size-12 border-primary/10 bg-card text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
            <CarouselNext className="relative inset-auto transform-none size-12 border-primary/10 bg-card text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}